import { graphql } from "../graphql";
import query from "./query.gql";
import { IRepoErrors } from "../errors";
import { FetchResult } from "@apollo/client";
import { graphqlExtractGraphqlErrors } from "@/v2/util/graphql-extract-graphql-errors";
import { graphqlRemapValidationErrors } from "@/v2/util/graphql-remap-validation-errors";
import {
  UserManagementTenantRoleEnum,
  UserManagementUserAccessTypeEnum,
} from "@/v2/enum/user-management";

interface IFetchInviteRequest {
  id: string;
  organizationId: string;
}

export async function fetchInvite(
  request: IFetchInviteRequest
): Promise<IFetchInviteResponse> {
  let response: FetchResult<any, Record<string, any>, Record<string, any>>;
  const errors: IRepoErrors<ValidationErrors> = {};

  try {
    response = await graphql.query({
      query,
      variables: {
        id: request.id,
        organizationId: request.organizationId,
      },
    });
  } catch (error) {
    errors.networkError = true;
    throw new FetchInviteError(errors);
  }

  if (response.errors) {
    errors.graphqlError = graphqlExtractGraphqlErrors(response);
    errors.validationError = graphqlRemapValidationErrors(response);
    throw new FetchInviteError(errors);
  }

  return response.data.invite;
}

export class FetchInviteError extends Error {
  errors: IRepoErrors<ValidationErrors>;

  constructor(errors: IRepoErrors<ValidationErrors>) {
    super("Error in repo: FetchInvite");
    this.errors = errors;
    this.name = this.constructor.name;
  }
}

type ValidationErrors = {};

interface IFetchInviteResponse {
  id: string;
  email: string;
  role: UserManagementTenantRoleEnum;
  accessibleResources: IAccessibleResources;
}

interface IAccessibleResources {
  accessType: UserManagementUserAccessTypeEnum;
  accessIds: Array<string>;
}
